import Typography from "@mui/material/Typography";
import { useStudioDetailsQuery } from "entities/studios/queries/useStudioDetailsQuery";
import { FC } from "react";
import { useImageUrl } from "shared/hooks/useImageUrl";
import { COLOR_WHITE } from "shared/theme/colors";
import { StyledChip } from "./styled";

interface StudioChipProps {
  studioId: string;
}

const StudioChip: FC<StudioChipProps> = ({ studioId }) => {
  const { data } = useStudioDetailsQuery({ studioId: Number(studioId) });
  const imageUrl = useImageUrl(data?.logo);

  return (
    <StyledChip>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={data?.name}
          style={{ maxWidth: 70, maxHeight: 22, objectFit: "contain" }}
        />
      ) : (
        <Typography variant="bodySRegular" sx={{ color: COLOR_WHITE }}>
          {data?.name}
        </Typography>
      )}
    </StyledChip>
  );
};

export default StudioChip;
